<template>
    <apexchart 
        style="overflow:auto"
        :height="height" :width="width" 
        :series="[
            {
                name: this.seriesName,
                type: this.chartType,
                data: this.series1
            },
            {
                name: 'Reminders',
                type: 'bar',
                data: this.series2
            },
        ]" 
        :options="options" />
</template>

<script>
export default {
    name: 'cohort-chart',
    props: [
        'series1', 'series2', 
        'maxvalue',
        'chartType', 'isPercent', 'isAmount'],
    data(){
        return {
        };
    },
    computed : {
        isMobileDevice:function(){
            let regexp = /android|iphone|kindle|ipad/i;
            return regexp.test(navigator.userAgent) || screen.width <= 600;
        },
        width: function(){
            return this.isMobileDevice ? 300 : Math.min(window.innerWidth - 300, 1200);
        },
        height: function(){
            return this.isMobileDevice ? 300 : 500;
        },
        seriesName:function(){
            return this.isAmount ? "Invoice Amount" : "Invoice Count"
        },
        options: function(){
            return {
                chart: {
                    zoom: {enabled: false},
                    toolbar: {show: false,},
                },
                fill: {opacity: this.getOpacity(),},
                stroke: {
                    width: this.getWidth(),
                    curve: 'smooth',
                    colors: this.getColors(),
                },
                grid: {
                    row: {
                        colors: ['transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                    padding: {
                        right: 30,
                        left: 30
                    },
                    show: true,
                    position: 'back',
                    borderColor: '#EEF0F3',
                },
                markers: {
                    size: 0,
                },
                xaxis: {
                    type: 'numeric',
                    title: { text: 'Days' },
                    tickAmount: 10,
                    axisBorder: {
                        show: true,
                        color: '#000000',
                        height: 0.1,
                    },
                    axisTicks:{show: false},
                    decimalsInFloat:0,
                    labels: {
                        formatter: (val) =>val.toFixed(0)
                    }
                },
                yaxis: [
                    {
                        seriesName: this.seriesName,
                        axisTicks: { show: true },
                        axisBorder: { show: true },
                        labels: {
                            formatter: (val) => {
                                if (this.isPercent){
                                    return val.toFixed(2) + "%"
                                }else if (this.isAmount){
                                    return this.$formatThousandsSeparator(val)
                                }else{
                                    return parseInt(val)
                                }
                            }
                        },
                        // max: (x) => this.isPercent? 100: this.maxvalue,
                        title: { text: this.isAmount ? "Amount (AED)" : " # Count", },
                    },
                    {
                        seriesName: 'Reminders',
                        axisTicks: {show: false,},
                        axisBorder: {show: false,},
                        labels: {show: false,},
                        title: {text: "",},
                    },
                ],
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '0.01%',
                        endingShape: 'rounded',
                        dataLabels: {
                            position: 'top',
                            offsetX: -6,
                            style: {
                                fontSize: '8px',
                                colors: ['#fff'],
                                width: 'fit-content',
                            }
                        },
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                tooltip: {
                    theme: 'dark',
                    enabled: true,
                    enabledOnSeries: [0],
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'right',
                    floating: false,
                },

            };
        }
    },
    methods: {
        getOpacity() {
            if (this.chartType == 'column') {
                return [0.1, 1];
            }
            else if (this.chartType == 'line') {
                return [1, 1];
            }
            else {
                return [0.2, 1];
            }
        },
        getColors() {
            if (this.chartType == 'column') {
                return ['#a2c0ec', '#04cd68d9'];
            }
            else {
                return ['#2774E9', '#04cd68d9'];
            }
        },
        getWidth() {
            if (this.chartType == 'column') {
                return [10, 1];
            }
            else if (this.chartType == 'line') {
                return [2, 1];
            }
            else if (this.chartType == 'area') {
                return [1, 1];
            }
        },
    },
}
</script>
